import React from 'react';
import { useTable } from "react-table";
import { Table} from "reactstrap";
import Loader from '../../utils/Loader';

const TableComponent = ({ columns, data, ...props }) => {
    const {
        getTableProps, 
        getTableBodyProps, // table body props from react-table
        headerGroups, 
        rows, 
        prepareRow 
    } = useTable({
        columns,
        data
    });
    
    const { sort, asc, applySort } = props;

    const sorting = key => {   

        if(key === sort){
            if(asc)
                return <i className="ml fas fa-sort-down"></i>
            else
                return <i className="ml fas fa-sort-up"></i>
        } else {
            return <i className="ml fas fa-sort"></i>
        }
    }

    return(
        <React.Fragment>
            <Table 
                {...getTableProps()} 
                className="table-centered datatable dt-responsive nowrap "
                style={{
                    borderCollapse: "collapse",
                    borderSpacing: 0,
                    position: "relative",
                    width: "100%",
                }}
            >
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => {
                                // console.log(column);
                                return (
                                <th style={{position: "sticky", top : "-5px", background: "white", "zIndex": "1"}}  {...column.getHeaderProps()} onClick={() => column.sortable && applySort(column.id)}>
                                    {column.render("Header")}
                                    {column.sortable  && <span className="ml-1">{sorting(column.id)}</span>}
                                </th>
                            )})}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    { console.log(props.loading )}
                    {
                        props.loading 
                        ?
                            <tr>
                                <td colSpan="6">
                                    <Loader />
                                </td>
                            </tr>
                        :
                            rows.length > 0 
                            ?
                                rows.map((row, i) => {
                                    prepareRow(row);
                                    return (
                                        <tr {...row.getRowProps()}  key={i}>
                                            {row.cells.map(cell => {
                                                return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                            })}
                                        </tr>
                                    );
                                })
                            :
                                <tr>
                                    <td colSpan="6">
                                        <p className="text-center text-danger"><strong>No Data To Display</strong></p>
                                    </td>
                                </tr>
                    }
                    {/* {rows.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                })}
                            </tr>
                        );
                    })} */}
                </tbody>
            </Table>
        </React.Fragment>
    )
}

export default TableComponent;